// ============================================================================
// REPOSITORY: SmartEntityLinkerRepository — busca de entidades por keyword
// ARQUIVO: src/services/SmartEntityLinkerRepository.js
// ============================================================================

import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';

const DEFAULT_APP_ID = 'portalrda-f312d';

export async function searchClientsByKeywords(keywords, appId = DEFAULT_APP_ID) {
  const ref = collection(db, ...FS.clients(appId));
  const queries = keywords.map((kw) => query(ref, where('searchKeywords', 'array-contains', kw), limit(8)));
  const snaps = await Promise.all(queries.map((q) => getDocs(q)));
  return snaps.flatMap((snap) => snap.docs);
}

// Fusão Processos/Caderno (MC27): processes vazia — redireciona para
// autos_workspaces, que ganhou searchKeywords no MC07. O nome da função já
// dizia "Matters", nunca "Processes" — indício de que a intenção de renomear
// já existia antes desta fusão.
export async function searchMattersByKeywords(keywords, appId = DEFAULT_APP_ID) {
  const ref = collection(db, ...FS.autosWorkspaces(appId));
  const queries = keywords.map((kw) => query(ref, where('searchKeywords', 'array-contains', kw), limit(8)));
  const snaps = await Promise.all(queries.map((q) => getDocs(q)));
  return snaps.flatMap((snap) => snap.docs);
}
